import axios, { AxiosResponse } from "axios";

import { UserLatestNotifications } from "@assets/types";
import store from "@state/store";

const NotificationAPI = process.env.NotificationAPI;

class NotificationService {
  getLatestNotifications = async (): Promise<UserLatestNotifications> => {
    const { userProfile } = store.getState().userProfileSlice;
    if (!userProfile) return Promise.reject("UserProfile not loaded");

    return axios
      .get<UserLatestNotifications>(
        `${NotificationAPI}/users/${userProfile.Access.UserID}/notifications/latest`,
        {
          withCredentials: true,
          headers: { "Content-Type": "application/json" },
        }
      )
      .then((res: AxiosResponse<UserLatestNotifications>) => res.data);
  };
}

export default new NotificationService();
